export default {
  cockpitApi: {
    // 获取天气数据
    getWeather: '/cockpitApi/getWeather',
    getConfig: '/cockpitApi/getConfig',
    // 获取地图jso数据
    getMapData: '/cockpitApi/getMapData',
    // 咨询总量数据
    consultations: '/cockpitApi/consultations',
    //咨询量数据
    consultationsNumber: '/cockpitApi/consultationsNumber',
    //获取咨询量分析数据
    consultationTrend: '/cockpitApi/consultationTrend',
    //获取业务类型数据
    bussinessInfo: '/cockpitApi/bussinessInfo',
    //获取客户类型数据
    crowdInfo: '/cockpitApi/crowdInfo',
    // 即时咨询
    realTime: '/cockpitApi/realTime',
    findActive: '/api/cockpitMgr/findActive',
    saveConfig: '/api/cockpitMgr/saveConfig',
    findMapData: '/api/cockpitMgr/findMapData'
  }
}